import { Component } from '@angular/core';

@Component({
  // Page not found component. Shown if router can't match the given route
  template: '<h2>Sorry page not found</h2>'
})
export class PageNotFoundComponent {}
